import { Swiper, Navigation, Pagination, Mousewheel } from "swiper";
import { format as formatDate } from "date-fns";

import { isMobile, getNumberId } from "../common/utils";

const showModalArticle = (articleId) => {
  const article = window.fstore.mediaCache.articles.find((article) => article.objectID == articleId);
  if (!article) {
    return;
  }
  const modal = document.querySelector("#modal-2023-article");
  const content = modal.querySelector(".fs-modal-content");
  renderArticle(article, content);

  content.addEventListener("click", hideModalArticle);
  modal.classList.add("show");
  document.querySelector("html").classList.add("overflow-hidden");
  setTimeout(() => {
    content.classList.add("show");
  }, 100);
};

const hideModalArticle = () => {
  const modal = document.querySelector("#modal-2023-article");
  const content = modal.querySelector(".fs-modal-content");
  content.removeEventListener("click", hideModalArticle);
  content.classList.remove("show");
  setTimeout(() => {
    modal.classList.remove("show");
    document.querySelector("html").classList.remove("overflow-hidden");
  }, 500);
};

const renderArticle = (article, element) => {
  const articleDate = formatDate(article.date * 1000, "yyyy年MM月dd日 HH:mm") + " JST";
  const link = article.permalink.includes("http")
    ? article.permalink
    : `https://www.fashionsnap.com${article.permalink}`;
  const html = `
    <button class="fs-close-button"></button>
    <div class="fs-article-container">
      <div class="fs-article">

        <div class="fs-content">

          <div class="fs-image">
            <img src="${article.thumbnail.normal.replace("w_150", "w_832").replace("width=150", "width=832")}" alt="">
            <div class="fs-overlay"></div>
          </div>

          <div class="fs-texts">
            <h3>${article.title}</h3>
            <div class="fs-label-row">
              <a href="https://www.fashionsnap.com/article/inside/${article.mainCategory.slug}"
                 class="fs-label"
                 target="_blank">
                ${article.mainCategory.label}
              </a>
              <p>ファッションスナップドットストア</p>
            </div>
            <p class="fs-date">${articleDate}</p>
            <a href="${link}" target="_blank" class="fs-button"><span>記事を読む</span></a>
          </div>

        </div>

        <div class="fs-products"></div>

      </div>
    </div>
  `;
  element.innerHTML = html;

  if (!article.storeProductIds || article.storeProductIds <= 0) {
    showContainer();
    return;
  }

  const productsElement = element.querySelector(".fs-products");
  window.ShopifyClient.fetchProducts(article.storeProductIds)
    .then((products) => {
      renderProducts(products, productsElement);
    })
    .catch((error) => {
      /* console.error(error) */
    });
};

const renderProducts = (products, element) => {
  const productsHtml = products
    .map((product) => {
      let img = "";
      if (product.images?.edges?.[0]?.node.url) {
        img = `<img src="${product.images?.edges?.[0]?.node.url}&width=320" />`;
      }

      let price = product.priceRange.minVariantPrice.amount;
      let compareAtPrice = !product.compareAtPriceRange
        ? null
        : parseInt(product.compareAtPriceRange.minVariantPrice.amount);
      let priceText = `<span class="fs-price">&yen; ${new Intl.NumberFormat("ja-JP").format(price)}</span>`;
      if (compareAtPrice && price != compareAtPrice) {
        let discountRate = ((1.0 - price / compareAtPrice) * 100.0).toString().split(".")[0];
        priceText += ` <span class="fs-original-price">&yen;${new Intl.NumberFormat("ja-JP").format(compareAtPrice)}</span>`;
        priceText += ` <span class="fs-discount-rate">(${discountRate}%OFF)</span>`;
      }

      const salesTypes = !product.sales_type ? [] : product.sales_type.value.split(",");
      const coupon = product.tags.includes("クーポン対象");
      const campaign = product.tags.includes("キャンペーン対象");
      const restock = product.tags.includes("再入荷");

      return `
      <div class="swiper-slide">
        <a href="/products/${product.handle}">
          <div class="fs-product" data-product-id="${getNumberId(product.id)}">
            <div class="fs-image">
              ${img}
            </div>
            <div class="fs-texts">
              <p class="fs-vendor">${product.vendor}</p>
              <p class="fs-name">${product.title}</p>
              <p class="fs-price-row">${priceText}</p>
              <div class="fs-badges">
                ${salesTypes.includes("セール商品") ? '<div class="fs-badge sale">SALE</div>' : ""}
                ${salesTypes.includes("予約商品") ? '<div class="fs-badge presale">予約商品</div>' : ""}
                ${restock ? '<div class="fs-badge restock">再入荷</div>' : ""}
                ${product.totalInventory == 1 ? '<div class="fs-badge stock">残り1点</div>' : ""}
                ${product.totalInventory == 0 ? '<div class="fs-badge soldout">SOLD OUT</div>' : ""}
                ${coupon ? '<div class="fs-badge sale">クーポン対象</div>' : ""}
                ${campaign ? '<div class="fs-badge sale">キャンペーン対象</div>' : ""}
              </div>
            </div>
          </div>
        </a>
      </div>
    `;
    })
    .join("");

  const html = `
    <div class="fs-products-content">
      <div class="swiper">
        <div class="fs-swiper-header">
          <h4>関連アイテム</h4>
          <div class="swiper-pagination"></div>
          <div class="fs-navigation-buttons">
            <div class="swiper-navigation-prev"></div>
            <div class="swiper-navigation-next"></div>
          </div>
        </div>
        <div class="swiper-wrapper">
          ${productsHtml}
        </div>
      </div>
    </div>
  `;

  element.innerHTML = html;
  setupSwiper(element);
};

const setupSwiper = (element) => {
  const offset = isMobile() ? 20 : 0;
  const swiperElement = element.querySelector(".swiper");
  const _ = new Swiper(swiperElement, {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 1.4,
    spaceBetween: 8,
    slidesOffsetBefore: offset,
    slidesOffsetAfter: offset,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      sensitivity: 0.1,
      thresholdDelta: 10,
    },
    navigation: {
      nextEl: ".swiper-navigation-next",
      prevEl: ".swiper-navigation-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 2.2,
      },
    },
    watchOverflow: true,
    on: {
      init: () => {
        showContainer();
      },
      resize: (instance) => {
        if (instance.navigation.prevEl) {
          instance.navigation.prevEl.classList.toggle("hidden", instance.slides.length <= 2);
        }
        if (instance.navigation.nextEl) {
          instance.navigation.nextEl.classList.toggle("hidden", instance.slides.length <= 2);
        }
      },
      slidesLengthChange: (instance) => {
        setTimeout(() => {
          instance.updateSlides();
        }, 400);
      },
    },
  });
};

const showContainer = () => {
  const articleContainer = document.querySelector(".fs-article-container");
  articleContainer.classList.add("show");
  articleContainer.querySelector(".fs-article").addEventListener("click", (e) => e.stopPropagation());
};

const ModalArticle = () => {
  return {
    showModalArticle: showModalArticle,
    hideModalArticle: hideModalArticle,
  };
};

export default ModalArticle;
